import React, { useState } from 'react'
import { Box, VStack, HStack, Text, Button, Flex } from '@chakra-ui/react'
import { ArrowBackIcon } from '@chakra-ui/icons'
import { AccountSettings } from './accountSettings/AccountSettings'
import { UserManagement } from './userManagement/UserManagement'
import { useNavigate } from 'react-router-dom'
import { Logo } from '../../../assets/icons/Logo'
import { AccountIcon } from '../../../assets/icons/AccountIcon'
import { UserManagementIcon } from '../../../assets/icons/UserManagementIcon'
import { DeviceConfigurationIcon } from '../../../assets/icons/DeviceConfigurationIcon'
import DeviceConfigurationSettings from './deviceConfiguration/DeviceConfigurationSettings'
import { DeviceGroupIcon } from '../../../assets/icons/DeviceGroups'
import { DeviceGroups } from './groupConfiguration/DeviceGroups'

export function SettingsScreen() {
  const [selectedTab, setSelectedTab] = useState('Account')
  const navigate = useNavigate()

  const renderContent = () => {
    switch (selectedTab) {
      case 'Account':
        return <AccountSettings />
      case 'User Management':
        return <UserManagement />
      case 'Device Configuration':
        return <DeviceConfigurationSettings />
      case 'Device Groups':
        return <DeviceGroups />
      default:
        return null
    }
  }

  const handleBack = () => {
    navigate('/dashboard')
  }

  return (
    <Flex height="100vh">
      <Box
        w="260px"
        bg="white"
        borderRight="1px"
        borderColor="gray.200"
        p={5}
        position="fixed"
        top="0"
        left="0"
        height="100vh"
      >
        <Logo w={40} h={10} flex={1} mb="10" />
        <VStack align="start" spacing={4} fontWeight="semibold">
          <Button
            leftIcon={<ArrowBackIcon />}
            colorScheme="gray"
            variant="ghost"
            mb={4}
            padding={0}
            width="100%"
            justifyContent="start"
            onClick={handleBack}
          >
            Back to Dashboard
          </Button>
          <HStack
            spacing={3}
            cursor="pointer"
            color={selectedTab === 'Account' ? 'blue.600' : 'gray.800'}
            onClick={() => setSelectedTab('Account')}
          >
            <AccountIcon boxSize={6} />
            <Text
              color={selectedTab === 'Account' ? '#484848' : '#707070'}
              fontWeight={selectedTab === 'Account' ? 700 : 400}
              fontFamily="Inter"
              fontSize="14px"
            >
              Account
            </Text>
          </HStack>
          <HStack
            spacing={3}
            cursor="pointer"
            color={selectedTab === 'User Management' ? 'blue.600' : 'gray.800'}
            onClick={() => setSelectedTab('User Management')}
          >
            <UserManagementIcon boxSize={5} />
            <Text
              color={selectedTab === 'User Management' ? '#484848' : '#707070'}
              fontWeight={selectedTab === 'User Management' ? 700 : 400}
              fontFamily="Inter"
              fontSize="14px"
            >
              User Management
            </Text>
          </HStack>
          <HStack
            spacing={3}
            cursor="pointer"
            color={selectedTab === 'Device Configuration' ? 'blue.600' : 'gray.800'}
            onClick={() => setSelectedTab('Device Configuration')}
          >
            <DeviceConfigurationIcon boxSize={5} />
            <Text
              color={selectedTab === 'Device Configuration' ? '#484848' : '#707070'}
              fontWeight={selectedTab === 'Device Configuration' ? 700 : 400}
              fontFamily="Inter"
              fontSize="14px"
            >
              Device Configuration
            </Text>
          </HStack>
          <HStack
            spacing={3}
            cursor="pointer"
            color={selectedTab === 'Device Groups' ? 'blue.600' : 'gray.800'}
            onClick={() => setSelectedTab('Device Groups')}
          >
            <DeviceGroupIcon boxSize={5} />
            <Text
              color={selectedTab === 'Device Groups' ? '#484848' : '#707070'}
              fontWeight={selectedTab === 'Device Groups' ? 700 : 400}
              fontFamily="Inter"
              fontSize="14px"
            >
              Device Groups
            </Text>
          </HStack>
        </VStack>
      </Box>

      <Box flex={1} p={8} ml="260px">
        {renderContent()}
      </Box>
    </Flex>
  )
}
